export function EncodeLineBreak(text) {
    return text.replaceAll("\n","%0A");
}

export function DecodeLineBreak(text) {
    return text.replaceAll("%0A","\n");
}